import { useMemo, useState } from "react";

import type { JobLogEntry } from "../lib/parseJobLogEvent";

import { useLogMarkerFilter } from "./useLogMarkerFilter";

export const useLogRoomFilter = (lines: readonly JobLogEntry[]) => {
  const { hasValues, isSelected, matches, selectedValues, toggle, values } = useLogMarkerFilter(lines, "Room");
  const [search, setSearch] = useState("");
  const query = search.trim().toLowerCase();
  const selectedSet = useMemo(() => new Set(selectedValues), [selectedValues]);
  const availableRooms = useMemo(() => {
    const unselected = values.filter((room) => !selectedSet.has(room));
    if (!query) return unselected;
    return unselected.filter((room) => room.toLowerCase().includes(query));
  }, [query, selectedSet, values]);

  return {
    availableRooms,
    hasRooms: hasValues,
    isSelected,
    matchesRoom: matches,
    search,
    selectedRooms: selectedValues,
    setSearch,
    toggle,
  };
};
